import { useEffect, useState } from "react";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useFormik } from "formik";
import * as Yup from "yup";
import DynamicEmployeeForm from "../../EmployeeList/DynamicEmployeeForm";

const RelationshipInfo = (params) => {
  const {
    employeeAllData,
    employeeId,
    employeeKeyDeta,
    EmployeeBasicDetails,
    updateEmployeeDetails,
  } = params;
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [employeeCreate, setEmployeeCreate] = useState(false);
  const [backButtonHide, setBackButtonHide] = useState(false);
  const [employeeRelationshipFormData, setEmployeeRelationshipFormData] =
    useState([]);

  const handleClick = () => {
    updateEmployeeDetails();
  };

  useEffect(() => {
    permissionAccouncementList();
    if (employeeKeyDeta) {
      let RelationshipForm = employeeKeyDeta?.filter(
        (item) => item.KeyCategoryName == "Relationship"
      );
      setEmployeeRelationshipFormData(RelationshipForm);
    }
  }, [employeeKeyDeta]);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Employee.Create") {
        setEmployeeCreate(true);
      }
    });
  };

  const hasRequiredData = EmployeeBasicDetails?.some(
    (data) => data?.KeyCategoryId === 102
  );

  const handleCloseBasicInfoModal = () => {
    document.querySelector("#edit-relationship-info .btn-close")?.click();
  };

  const renderForm = (type) => {
    handleClick();
    if (type == "profile") {
      const tabTriggerEl = document.querySelector('a[href="#my-posts"]');
      document.querySelector("#edit-relationship-info .btn-close")?.click();
      if (tabTriggerEl) {
        const tab = new window.bootstrap.Tab(tabTriggerEl);
        tab.show();
      }
    }
  };

  const userInfoValidation = Yup.object().shape({
    gender: Yup.string().required("Gender is required."),
    dob: Yup.string().required("DOB is required."),
    married: Yup.string().required("Married to is required."),
  });

  const basicInfoForm = useFormik({
    initialValues: {
      gender: "",
      dob: "",
      married: "",
    },
    validationSchema: userInfoValidation,
    onSubmit: async (data) => {
      const body = {};
    },
  });

  return (
    <>
      <div className="mb-4">
        {hasRequiredData ? (
          <div className="form-head stuck-headers33 mt-3">
            <div className="form-head stuck-header profile-about-me">
              <div className="mb-0">
                <h4 className="text-primary mb-3 sumh4 addprofile-action">
                  Relationship Info
                  {userDetails?.EmpId == employeeId && (
                    <span>
                      <a
                        aria-label="Relationship"
                        className="edit-btncss mb-2 love-icon"
                        data-bs-toggle="modal"
                        data-bs-target="#edit-relationship-info"
                        title="Edit"
                      >
                        <img
                          src="/images/org-img/edit.png"
                          className=""
                        />
                      </a>
                    </span>
                  )}
                </h4>
                <div className="languages-wrapper90">
                  {EmployeeBasicDetails?.filter(
                    (data) => data?.KeyCategoryId === 102
                  )
                    .sort((a, b) => a.KeyDisplayOrder - b.KeyDisplayOrder)
                    .map((data) => (
                      <>
                        {data.InferredValue != "" && data.InferredValue != null && (
                          <div className="languages-item" key={data.Id}>
                            <div className="icon-wrap">
                              <LazyImage src={data?.Icon} />
                            </div>
                            <div className="meta">
                              <span className="dark-inverted">
                                {data.KeyDesc}
                              </span>
                              <span>{data.InferredValue}</span>
                            </div>
                          </div>
                        )}
                      </>
                    ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
           
          </>
        )}
      </div>

      <div
        id="edit-relationship-info"
        className="modal fade custom-modal-area"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content add-editexperience">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/popup-icons/featured-post.png" />
              </div>
              <button
                onClick={handleCloseBasicInfoModal}
                type="button"
                className="btn-close m-auto"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <h5 className="modal-title text-center">Relationship Information</h5>

              {employeeRelationshipFormData.length > 0 && (
                <DynamicEmployeeForm
                  employeeKeyDeta={employeeRelationshipFormData}
                  employeeEditDetails={employeeAllData}
                  renderForm={renderForm}
                  backButtonHideStatus={backButtonHide}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RelationshipInfo;
